import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

const muiStyles = makeStyles((theme: typeof muiTheme) => ({
    headerText: {
        color: theme?.app?.applicationColors.fontDetailColor || '#4A4C50',
        fontSize: '.8rem',
        marginBottom: '.5rem'
    },
    transactionDescriptionContainer: { paddingLeft: '.5rem' },
    redText: { color: 'red' },
    greenText: { color: 'green' }
}));

export default muiStyles;